import { inject, type InjectionKey } from "vue";

export const openMobileChatDockKey: InjectionKey<() => void> = Symbol("openMobileChatDock");

export function useOpenMobileChatDock(): (() => void) | undefined {
  return inject(openMobileChatDockKey, undefined);
}
